import { SEND_QUOTE, QUOTE_SENDED } from 'containers/Offer/constants';

export function sendQuote(quote) {
  return {
    type: 'SEND_QUOTE',
    quote,
  };
}

export function quoteSended(quote) {
  return {
    type: QUOTE_SENDED,
    quote,
  };
}
